// project imports
import en from './locales/en';
import es from './locales/es';
import pt from './locales/pt';

// ==============================|| I18N - REGISTRO DE IDIOMAS ||============================== //
// Punto único donde se declara qué idiomas ofrece la web.
//
// El backend ya acepta `pt`; dejamos el diccionario y el selector de idioma
// registrados en un solo punto para que más módulos puedan compartirlo en
// función de `t(key)` y del catálogo de idiomas.

export const IDIOMA_POR_DEFECTO = 'es';

// `intlLocale` es el locale BCP 47 que reciben Intl.NumberFormat / DateTimeFormat.
// Se declara aquí y no se deriva del código de idioma para no depender del
// locale del navegador al formatear importes y fechas.
export const IDIOMAS = [
  { code: 'es', label: 'Español', intlLocale: 'es-CO' },
  { code: 'en', label: 'English', intlLocale: 'en-US' },
  { code: 'pt', label: 'Português', intlLocale: 'pt-BR' }
];

export const DICCIONARIOS = { es, en, pt };

export const CODIGOS_IDIOMA = IDIOMAS.map((idioma) => idioma.code);

/**
 * Normaliza cualquier código recibido (backend, localStorage, navegador) a uno
 * de los idiomas que la web sabe mostrar.
 *
 * El backend acepta también 'pt'; mientras la web no lo traduzca, un usuario con
 * esa preferencia ve la interfaz en el idioma por defecto en lugar de romperse.
 */
export function resolveLocale(code) {
  if (!code) return IDIOMA_POR_DEFECTO;

  const normalizado = String(code).toLowerCase().split(/[-_]/)[0];
  return CODIGOS_IDIOMA.includes(normalizado) ? normalizado : IDIOMA_POR_DEFECTO;
}

export function intlLocaleDe(code) {
  const idioma = IDIOMAS.find((item) => item.code === resolveLocale(code));
  return idioma.intlLocale;
}
